export interface SalesOrderLinePreviousOrders {
  id: string;
  salesOrderAndLineNo: string;
  dateOrdered: Date;
  orderTypeDescription: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  priceListQty: number;
  cuom: string;
  price: number;
  discount: number;
  deliveryDate: Date;
  currencyDiscountValue: number;
  exStock: string;
}
